var map = {
	"./ATOM.png": 98614,
	"./CLND.png": 25265,
	"./DAI.png": 26221,
	"./EVMOS.png": 50769,
	"./FRAX.png": 59748,
	"./OSMO.png": 34388,
	"./SOL.png": 51256,
	"./USDC.png": 57547,
	"./USDT.png": 56789,
	"./WBTC.png": 78054,
	"./WETH.png": 71623
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11346;